import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const AccessDeniedPage = () => {
  return (
    <main className="min-h-screen flex items-center justify-center bg-background px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-lg bg-card border border-border rounded-xl p-10 text-center shadow-[0_8px_30px_rgba(0,0,0,0.08)]"
      >
        <h1 className="text-5xl font-light italic text-primary mb-4">
          Access Denied
        </h1>

        <p className="text-foreground/70 mb-6 leading-relaxed">
          You do not have permission to access this page.
        </p>

        <Link
          to="/"
          className="px-8 py-3 bg-primary text-primary-foreground rounded-lg font-semibold shadow hover:shadow-md transition"
        >
          Go Back Home
        </Link>
      </motion.div>
    </main>
  );
};
